import { usePurchaseOrderMainCommentForm } from '@/features/purchase-order/hooks/use-purchase-order-main-comment-form';
import type { PurchaseOrderCommentValues } from '@/features/purchase-order/schema/purchase-order-comment-schema';
import { apiValidationErrorHandler } from '@/lib/api-validation-error-handler';
import { useCreatePurchaseOrderComment } from '@/services/apis/mutations/purchase-orders/use-create-purchase-order-comment';

type PurchaseOrderCommentCreateProps = {
  purchaseOrderId: string;
  setOpen: (value: boolean) => void;
};

const emptyComment = {
  id: 0,
  value: '',
};

export function usePurchaseOrderMainCommentCreate({
  purchaseOrderId,
  setOpen,
}: PurchaseOrderCommentCreateProps) {
  const { control, handleSubmit, setError, reset } =
    usePurchaseOrderMainCommentForm(emptyComment);
  const { mutate, isPending } = useCreatePurchaseOrderComment(purchaseOrderId);

  const onSubmit = (data: PurchaseOrderCommentValues) => {
    mutate(
      { purchaseOrderId, value: data.value },
      {
        onSuccess: () => {
          setOpen(false);
          resetToEmpty();
        },
        onError: apiValidationErrorHandler(setError),
      },
    );
  };

  const resetToEmpty = () => {
    setTimeout(() => {
      reset(emptyComment);
    }, 100);
  };

  return {
    control,
    handleSubmit,
    onSubmit,
    isSubmitting: isPending,
    resetToEmpty,
  };
}
